import classNames from 'classnames';
import { Tooltip } from 'flowbite-react';
import React from 'react';
import { isScoreRangeValid } from 'shared-utils';
import { UIBadge, UserSkillRatingDocument } from 'types';

interface Props {
	badge: UIBadge;
	skills: UserSkillRatingDocument[];
}

export const getBadgeIcon = (badge: UIBadge) => {
	switch (badge.title) {
		case 'Expert':
			return { icon: '/assets/badges/expert.svg', borderColor: 'border-[#3E7BFA]' };
		case 'Advanced':
			return { icon: '/assets/badges/advanced.svg', borderColor: 'border-[#E7BA04]' };
		case 'Intermediate':
			return { icon: '/assets/badges/intermediate.svg', borderColor: 'border-[#1971F7]' };
		case 'Beginner':
			return { icon: '/assets/badges/beginner.svg', borderColor: 'border-[#05B79C]' };
		default:
			return { icon: '/assets/badges/expert.svg', borderColor: 'border-[#3E7BFA]' };
	}
};

const BadgeCard = ({ badge, skills }: Props) => {
	const filteredSkills = skills?.map(skill => skill?.skill?.name)?.sort((a, b) => a.length - b.length);

	return filteredSkills?.length > 0 ? (
		<div className="md:min-w-[150px] font-inter px-2 md:flex-1 md:px-5 py-6 flex flex-row gap-4 justify-start items-start dark:border dark:border-slate-700 rounded-[4px] border border-[#F2F2F5]">
			<div>
				<div
					className={classNames(
						'rounded-full h-full w-full flex relative justify-center items-center border overflow-hidden',
						getBadgeIcon(badge)?.borderColor,
					)}
				>
					<img src={getBadgeIcon(badge)?.icon} alt="badge" className="min-w-[71px]" />
				</div>
			</div>
			<div>
				<p className="mt-[4px] text-sm md:text-base font-[500] text-[#1C1C28] dark:text-[#E4E4EB]">
					{badge.title} in {filteredSkills.length} {filteredSkills.length > 1 ? 'skills' : 'skill'}
				</p>
				<p className="mt-[2px] text-[9px] font-[400] leading-[16px] text-[#8F90A6] dark:text-[#C7C9D9]">
					Score: {badge?.scoreRange}
				</p>
				<p className="mt-[4px] md:mt-[8px] text-[10px] md:text-xs font-[500] text-[#555770] dark:text-[#CDF] text-left">
					{filteredSkills?.join(', ')}
				</p>

				{/* <Tooltip
					content={
						<p className="text-white max-w-[300px]">
							Skills: {filteredSkills?.length === 0 ? 'No Skills Found' : filteredSkills?.join(', ')}
						</p>
					}
					trigger="hover"
					placement="bottom"
					arrow={false}
					className="mb-0 !rounded-[5px] dark:bg-[#1F2A37] dark:text-[#8b8e94] sm:right-0 sm:!max-w-[255px]"
				>
					<p className="mt-[4px] text-[14px] font-[400] leading-[20px] text-[#555770] dark:text-[#CDF] text-center">
						{filteredSkills?.length === 0 ? (
							'-'
						) : filteredSkills?.length > 1 ? (
							<>
								{filteredSkills[0]?.length > 8 ? filteredSkills[0].slice(0, 8) + '...' : filteredSkills[0]},{' '}
								<span className="underline whitespace-pre">{filteredSkills?.length - 1} more</span>
							</>
						) : (
							filteredSkills?.join(', ')
						)}
					</p>
				</Tooltip> */}
			</div>
		</div>
	) : null;
};

export default BadgeCard;
